<style lang="less">
    .page_con.play{
        height:100vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;

    }
    .art_content{
        width:100%;
        overflow: hidden;
        position: relative;
        flex:1;
        // padding:.6rem 0 0;
        // display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .pd{
            width:100%;
            // flex:1;
            margin-top:.6rem;
            padding: 0 .2rem;
        }
    }
    .art_text_con{
        width:100%;
        height:auto;
        background: #78D3FF;
        border:2px solid #1D2088;
        box-shadow:0px .08rem .02rem 0px rgba(0, 0, 0, 0.3);
        border-radius: .1rem;
        padding:.6rem .2rem .2rem;
        position: relative;
        z-index: 9;
        >img{
            width:100%;
            height:auto;
            display: block;
        }
        .art_inner{
            width:100%;
            background:#FFFDE4;
            padding:.2rem .4rem 0;
            position: relative;
            >div{
                width:100%;
                height:100%;
                // overflow-x: hidden;
                overflow-y: auto;
                >img{
                    width:100%;
                    height:auto;
                    display: block;
                    margin-bottom: .4rem;
                }
            }
            >img.table{
                width:2.5rem;
                height:auto;
                margin:0;
                position: relative;
                right:-.4rem;
                bottom:.4rem;
                z-index: 11;
            }
            >img.child{
                width:3rem;
                height:auto;
                margin:0;
                position: relative;
                left:0rem;
                bottom:.3rem;
                z-index: 11;
                transform: scale(1.1);
                margin-bottom: -.2rem;
            }
        }
    }
    .play_video_con{
        width:100%;
        height:auto;
        min-height: 250px;
        padding:0.6rem 0.8rem 1.2rem;
        background:url("../assets/images/blackboard-phone.png") no-repeat;
        background-size:100% 100%;
        >div{
            position: relative;
            video{
                width:100%;
                height:auto;
                margin:0 auto;
            }
            .btn{
                width:10%;
                height:auto;
                border-radius: 50%;
                // background: url("../assets/images/number-btn.png") no-repeat;
                // background-size:100% 100%;
                font-size:.3rem;
                color:#fff;
                position: absolute;
                left:0;
                top:0;
                z-index: 11;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all .5s;
                img{
                    width:100%;
                    height:auto;
                    display: block;
                }
            }
            .tips_text{
                width:max-content;
                font-size: .32rem;
                color:#fff;
                transform: translateX(-50%);
                position: absolute;
                left:50%;
                bottom:-.5rem;
                z-index: 11;
            }
        }
        .res_right,.res_wrong{
            width:100%;
            height:100%;
            font-size: .8rem;
            text-align: center;
            color:#fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: absolute;
        }
    }
</style>
<template>
    <div>
        <div class="pd">
            <div class="art_text_con"><!-- 蓝底 padding -->
                <img src="../assets/images/up-article-phone.png" alt="">
                <div class="art_inner"><!-- 黄底 padding -->
                    <div>
                        <div class="play_video_con">
                            <div>
                                <video ref="video" poster="../assets/images/text.png" playsinline  webkit-playsinline preload>
                                    <source type="video/mp4" :src="imgBaseUrl + gameData.opts.src"></source>
                                </video>
                                
                                <div v-for="(item,index) in gameData.opts.data" @click="clickStrokes(item,index)" :left="item.left" :style="'left:'+item.left+'%;'+'top:'+item.top+'%;'" :key="index" class="btn" :class="{'active':item.is_right}">
                                    <img v-if="item.is_right" :aaa="item.is_right" src="../assets/images/right.png" alt="">
                                    <img v-else src="../assets/images/number-btn.png" alt="">
                                </div>
                                <div class="tips_text">你要寫對1次才能完成練習</div>
                            </div>
                            <!-- <div v-if="status == 'right'" class="res_right">
                                <span>答對了！</span>
                            </div> -->
                        </div>
                    </div>
                    <img src="../assets/images/children.gif" alt="" class="child">
                    <img src="../assets/images/platform-pc.png" alt="" class="table">
                </div>
                <img src="../assets/images/down-article-phone.png" alt="">
            </div>
        </div>
        <!-- <div class="art_bottom">
            <img class="art_bottom_bg" src="../assets/images/bg3-phone.png" alt="">
            <img class="art_bottom_flowers" src="../assets/images/flowers.gif" alt="">
            <img class="art_bottom_sunflowers" src="../assets/images/sunflower.gif" alt="">
        </div> -->
    </div>
</template>
<script>
export default {
    props:{
        gameData:{
            type:Object,
            default:{},
        },
        game_id:{
            type:String,
            default:'1',
        },
        date:{
            type:String,
            default:'',
        },
        push_id:{
            type:String,
            default:'',
        }
    },
    data(){
        return {
            status:'wait',
            btnSort:0,      //当前第几笔
            // srouce:{
            //     data:[
            //         {
            //             btnId: 0,
            //             left: "29.67",
            //             time: 0,
            //             top: "26.67",
            //             is_right:false,
            //         },
            //         {
            //             btnId: 1,
            //             left: "44.33",
            //             time: 1.6700,
            //             top: "12.67",
            //             is_right:false,
            //         },
            //         {
            //             btnId: 2,
            //             left: "44.67",
            //             time: 3.295678,
            //             top: "35.33",
            //             is_right:false,
            //         },
            //         {
            //            btnId: 3,
            //             left: "26.33",
            //             time: 4.908946,
            //             top: "59.67",
            //             is_right:false,
            //         },
            //         {
            //             btnId: 4,
            //             left: "67.67",
            //             time: 5.906225,
            //             top: "63.00",
            //             is_right:false,
            //         },
            //     ]
            // }
        }
    },
    mounted(){
        console.log('寫一寫',this.gameData);
        this.initVideo();
    },
    methods:{
        clickStrokes(item,index){
            if(item.btnId == this.btnSort){
                console.log('视频暂停时间：',item.time);
                this.btnSort++;
                // item.is_right = true;
                this.$set(this.gameData.opts.data[index],'is_right',true);
                this.$refs.video.play();
            }else{
                console.log('error');
                // alert('我是第'+(index+1)+'笔');
                alert('写错了');
            }
        },
        initVideo(){
            let video = this.$refs.video;
            video.ontimeupdate = this.updateTime;
        },
        // timeWatch(){        //定时器的方式暂停  问题：因为cpu的处理速度不一样，代码执行完成的时间不一样，导致暂停的时间也不一样
        //     if(this.btnSort == this.srouce.data.length){  //最后一个按钮点完不用再判断
        //         return;
        //     }
        //     console.log('倒计时',this.srouce.data[this.btnSort].time);
        //     this.pause_timer = setTimeout(()=>{
        //         let video = this.$refs.video;
        //         console.log('视频已暂停',video.currentTime);
        //         this.$refs.video.pause();
        //         this.pause_timer && clearTimeout(this.pause_timer);
        //         this.pause_timer = null;
        //     },this.srouce.data[this.btnSort].time * 1000 - this.srouce.data[this.btnSort-1].time * 1000);
        // },
        updateTime(e){
            console.log(e);
            if(this.btnSort == this.gameData.opts.data.length){  //最后一个按钮点完不用再判断
                let vm = this;
                this.$http.get(this.baseUrl+"/Game/writePush/GaID/"+this.game_id+"/SrtSet/1/SrtTime/"+ 5 + '/pushdate/'+ this.date  +"/sn/"+ Math.random()).then(res=>{
                    console.log(res)
                    if(res.data.indexOf('pass')>-1){
                        vm.status = 'right';
                        setTimeout(()=>{
                            vm.$emit('next');
                        },3000)
                    }else{
                    }
                    vm.is_answered = true;
                })
                return;
            }
            if(e.target.currentTime >= this.gameData.opts.data[this.btnSort].time ){
                console.log('视频已暂停',e.target.currentTime);
                this.$refs.video.pause();
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/game-write.vue